<template>
    <div>
      <b-row>
        <b-col sm="5" lg="5">
          <div class="dashboard-chart">
            <h4>Ventas x Cliente</h4>
            <p class="description">Últimos 12 meses</p>
            <ranking ref="ranking"></ranking>
          </div>
        </b-col>
        <b-col sm="7" lg="7">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="resultadosVentasClientes" 
              :fields="resultadosVentasClientesFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(color)="data">
                <div class="color-reference" :style='"background-color: " + getColor(data.item) + ";"'></div>              
            </template>
            <template v-slot:cell(montoNeto)="data">
              {{ data.item.montoNeto | moneda }}
            </template>
            <template v-slot:cell(pjeParticipacion)="data">
              {{ data.item.pjeParticipacion | porcentaje }}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import Ranking from '../../charts/Pie';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs'

export default {
  components: {
    Ranking,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],

data() {
    return {
      key: 0,
      tableBusy: false,

      resultadosVentasClientes: [],
      resultadosVentasClientesFields: [
        { 
          key: 'color',
          label: 'Ref.'
        },
        { key: 'cliente' },
        { 
          key: 'montoNeto',
          class: 'text-right'
        },
        { 
          key: 'pjeParticipacion',
          class: 'text-right'
        },
      ],
    }
  },
  created() {
  },
  methods: {
    getResultados() {
      this.$store.dispatch('indicadoresCuentas/getResultadosVentasClientes')
        .then(() => {
          this.resultadosVentasClientes = this.$store.getters['indicadoresCuentas/resultadosVentasClientes'];
          let labels = this.$store.getters['indicadoresCuentas/resultadosVentasClientesLabels'];
          let colors = this.$store.getters['indicadoresCuentas/resultadosVentasClientesColors'];
          let data = this.$store.getters['indicadoresCuentas/resultadosVentasClientesData'];

          this.$refs.ranking.render(labels, colors, data, false);
        });
    },
    getColor(item) {
      return item.color;
    },
  }
}
</script>

<style>
</style>